class FlashSaleCountdown extends HTMLElement {
  connectedCallback() {
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
    this.titleEl = this.closest('.tn-flash-sale-countdown')?.querySelector('[data-countdown-title]');

    try {
      this.schedule = JSON.parse(this.dataset.schedule || '[]');
    } catch {
      this.hideSection();
      return;
    }
    this.utcOffsetMs = this.parseOffsetToMs(this.dataset.utcOffset || '+00:00');
    this.activeTitle = this.dataset.activeTitle || '';
    this.nextTitle = this.dataset.nextTitle || '';

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  parseOffsetToMs(offset) {
    const sign = offset.startsWith('-') ? -1 : 1;
    const [hours, minutes] = offset.replace(/[+-]/, '').split(':').map(Number);
    return sign * ((hours * 60 + minutes) * 60 * 1000);
  }

  toStoreLocalParts(utcMs) {
    const shifted = new Date(utcMs + this.utcOffsetMs);
    return {
      weekday: shifted.getUTCDay(),
      dateOnlyMs: Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate()),
    };
  }

  storeLocalToUtcMs(dateOnlyMs, hour, minute) {
    return dateOnlyMs + (hour * 60 + minute) * 60 * 1000 - this.utcOffsetMs;
  }

  findWindows(nowMs) {
    const { dateOnlyMs: todayMs } = this.toStoreLocalParts(nowMs);
    const active = [];
    let soonestUpcoming = null;

    for (const config of this.schedule) {
      if (!config.active) continue;

      // Safe as long as no config's durationHours exceeds ~7 days (168h) --
      // the schema's max: 96 keeps this well within the ±8 day search window.
      for (let offset = -8; offset <= 8; offset++) {
        const candidateDateMs = todayMs + offset * 24 * 60 * 60 * 1000;
        const candidateWeekday = new Date(candidateDateMs).getUTCDay();
        if (candidateWeekday !== config.day) continue;

        const start = this.storeLocalToUtcMs(candidateDateMs, config.startHour, config.startMinute);
        const end = start + config.durationHours * 60 * 60 * 1000;

        if (nowMs >= start && nowMs < end) {
          active.push({ start, end });
        } else if (start > nowMs && (soonestUpcoming === null || start < soonestUpcoming)) {
          soonestUpcoming = start;
        }
      }
    }

    return { active, soonestUpcoming };
  }

  hideSection() {
    const wrapper = this.closest('.tn-flash-sale-countdown');
    if (wrapper) wrapper.hidden = true;
    this.hidden = true;
    clearInterval(this.interval);
  }

  tick() {
    if (this.schedule.every((config) => !config.active)) {
      this.hideSection();
      return;
    }

    const nowMs = Date.now();
    const { active, soonestUpcoming } = this.findWindows(nowMs);

    let target;
    let title;

    if (active.length > 0) {
      target = Math.max(...active.map((window) => window.end));
      title = this.activeTitle;
    } else if (soonestUpcoming !== null) {
      target = soonestUpcoming;
      title = this.nextTitle;
    } else {
      this.hideSection();
      return;
    }

    if (this.titleEl) this.titleEl.textContent = title;

    const remaining = target - nowMs;
    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('flash-sale-countdown', FlashSaleCountdown);
